export enum PaymentRailType {
  COP = 'COP',
  PIX = 'PIX',
  SPEI = 'SPEI',
  CVU = 'CVU',
  ACH = 'ACH',
  RTP = 'RTP',
  Wire = 'WIRE',
  Polygon = 'POLYGON',
  LocalExchange = 'LOCAL_EXCHANGE',
  TRON = 'TRON',
  Ethereum = 'ETH',
  Swift = 'SWIFT',
  CalizaWallet = 'CALIZA_WALLET',
  unset = '',
}

// TODO: move to a separate file
export enum CurrencyCodeType {
  USDC = 'USDC',
  USDT = 'USDT',

  USD = 'USD',
  BRL = 'BRL',
  MXN = 'MXN',
  COP = 'COP',

  ARS = 'ARS',
  HKD = 'HKD',
  SGD = 'SGD',

  ANY = 'ANY',
  UNSET = '',
}

export interface CurrencyWithSwiftFlag {
  readonly currency: CurrencyCodeType;
  readonly swift: boolean;
}

export interface FundingMethodItem {
  readonly id: string;
  readonly method: PaymentRailType;
  readonly currency: CurrencyCodeType;
  readonly fundingSource?: 'customer' | 'integrator';
}

export interface DashboardOperationDestination {
  readonly currency: CurrencyCodeType;
  readonly rail: PaymentRailType;
  readonly fundingMethods: readonly PaymentRailType[];
}

export interface DashboardOperation {
  readonly currency: CurrencyCodeType;
  readonly destinations: readonly DashboardOperationDestination[];
}
